var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11127 10.8124C7.35673 10.8124 7.55572 11.0181 7.55572 11.2719V13.0712C9.99905 11.5957 11.4691 10.5519 12.3556 9.64058C12.8701 9.11172 13.1531 8.66071 13.3175 8.23065C13.4828 7.79823 13.5557 7.31509 13.5557 6.67685C13.5557 4.39287 11.7649 2.54133 9.55572 2.54133H6.44461C4.23547 2.54133 2.44461 4.39287 2.44461 6.67685C2.44461 8.96084 4.23547 10.8124 6.44461 10.8124H7.11127ZM7.55572 14.3991C13.4794 10.8746 14.6668 9.43102 14.6668 6.67685C14.6668 3.75843 12.3785 1.39258 9.55572 1.39258H6.44461C3.62182 1.39258 1.3335 3.75843 1.3335 6.67685C1.3335 9.59528 3.62182 11.9611 6.44461 11.9611V14.2665C6.44461 14.6181 6.8108 14.8393 7.10621 14.6652C7.25899 14.5752 7.40881 14.4865 7.55572 14.3991Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterComment);
export default __webpack_public_path__ + "static/media/twitterComment.9ebf71ec.svg";
export { ForwardRef as ReactComponent };